<nav class="side-nav" [class.collapsed]="collapsed()">
  <div class="nav-heading" *ngIf="!collapsed()">{{ translation.translate('portal') }}</div>

  <a
    *ngFor="let item of items"
    [routerLink]="item.path"
    routerLinkActive="active"
    class="nav-item"
    [attr.aria-label]="translatedLabel(item)"
  >
    <i class="nav-icon" [class]="item.icon" aria-hidden="true"></i>
    <span *ngIf="!collapsed()">{{ translatedLabel(item) }}</span>
  </a>

  <button
    pButton
    type="button"
    class="collapse-button p-button-text"
    [attr.aria-label]="translation.currentLanguage() === 'el' ? (collapsed() ? 'Ανάπτυξη μενού' : 'Σύμπτυξη μενού') : (collapsed() ? 'Expand navigation' : 'Collapse navigation')"
    (click)="toggleCollapsed()"
  >
    <i [class]="collapsed() ? 'pi pi-angle-right' : 'pi pi-angle-left'" aria-hidden="true"></i>
  </button>

  <img
    *ngIf="!collapsed()"
    src="assets/media/logos/logo_ethniki.png"
    alt="Εθνική Ασφαλιστική"
    class="ethniki-logo"
  />
</nav>
